export const CityType = Object.freeze({
  Country: 1,
  District: 2,
  Town: 3
});
